module.exports = __webpack_public_path__ + "static/media/SentrySafe_FP_Safe_Banner.eb3ee404.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/SentrySafe_FP_Safe_Banner.png
// module id = 1205
// module chunks = 0